import { Roles } from '../../../constants/roles'
import ecbrApi from '../../../services/ecbrApi'
import LocalStorageService from '../../../services/LocalStorageService'
import loginTypes from './types'

export const setIsLogged = (isLogged) => ({
  type: loginTypes.SET_IS_LOGGED,
  payload: {
    isLogged
  }
})

export const login = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: loginTypes.LOGIN
    })

    const { data: auth } = await ecbrApi.auth.login(email, password)
    LocalStorageService.set('token', auth['access_token'])
    const { data: profile } = await ecbrApi.auth.profile()
    LocalStorageService.set('user', profile)
    // const { data: company } = await ecbrApi.companies.getAllWithLoggedUser()
    // LocalStorageService.set('company', company)

    if (
      [Roles.ADMIN_USER, Roles.VIEWER_USER, Roles.PILLAR_OWNER].includes(
        profile.role
      )
    ) {
      dispatch({
        type: loginTypes.LOGIN_SUCCESS
      })

      return true
    }

    LocalStorageService.remove('token')
    LocalStorageService.remove('user')
    // LocalStorageService.remove('company')

    dispatch({
      type: loginTypes.LOGIN_FAILURE,
      payload: {
        formError: 'Usuário não autorizado'
      }
    })

    return false
  } catch (error) {
    LocalStorageService.remove('token')
    LocalStorageService.remove('user')
    // LocalStorageService.remove('company')

    let errorMessage = 'Email ou senha inválidos'
    if (error?.message === 'Network Error') {
      errorMessage = 'Não foi possível conectar ao servidor'
    }

    dispatch({
      type: loginTypes.LOGIN_FAILURE,
      payload: {
        formError: errorMessage
      }
    })

    return false
  }
}

export const loginAdmin = (email, password) => async (dispatch) => {
  try {
    dispatch({
      type: loginTypes.LOGIN
    })

    const { data: auth } = await ecbrApi.auth.login(email, password)
    LocalStorageService.set('token', auth['access_token'])
    const { data: profile } = await ecbrApi.auth.profile()
    LocalStorageService.set('user', profile)
    // const { data: company } = await ecbrApi.companies.getAllWithLoggedUser()
    // LocalStorageService.set('company', company)

    if ([Roles.ADMIN_ECBR, Roles.VIEWER_ECBR].includes(profile.role)) {
      dispatch({
        type: loginTypes.LOGIN_SUCCESS
      })

      return true
    }

    LocalStorageService.remove('token')
    LocalStorageService.remove('user')
    // LocalStorageService.remove('company')

    dispatch({
      type: loginTypes.LOGIN_FAILURE,
      payload: {
        formError: 'Usuário não autorizado'
      }
    })

    return false
  } catch (error) {
    LocalStorageService.remove('token')
    LocalStorageService.remove('user')
    // LocalStorageService.remove('company')

    let errorMessage = 'Email ou senha inválidos'
    if (error?.message === 'Network Error') {
      errorMessage = 'Não foi possível conectar ao servidor'
    }

    dispatch({
      type: loginTypes.LOGIN_FAILURE,
      payload: {
        formError: errorMessage
      }
    })

    return false
  }
}

export const loginSuccess = () => ({
  type: loginTypes.LOGIN_SUCCESS
})

export const loginFailure = (error) => ({
  type: loginTypes.LOGIN_FAILURE,
  payload: {
    error
  }
})

export const logout = () => async (dispatch) => {
  LocalStorageService.remove('token')
  LocalStorageService.remove('user')
  // LocalStorageService.remove('company')

  dispatch({
    type: loginTypes.LOGOUT
  })
}
